import axios from 'axios';

const defaultHeaders = {
  'Content-Type': 'application/json'
};

const baseURL = process.env.REACT_APP_BASE_URL;
const baseURLGo = process.env.REACT_APP_BASE_URL_GO;

export async function get<T>(
  url: string,
  customHeaders: Record<string, unknown> = {},
  goUrl?: boolean
): Promise<T> {
  const headers = { ...defaultHeaders, ...customHeaders };
  const apiBaseURL = goUrl ? baseURLGo : baseURL;

  try {
    const response = await axios.get<T>(`${apiBaseURL}${url}`, { headers });
    return response.data;
  } catch (error) {
    throw new Error('Houve um problema com a requisição.');
  }
}

export async function post<T>(
  url: string,
  bodyRequest: unknown,
  customHeaders: Record<string, unknown> = {},
  goUrl?: boolean
): Promise<T> {
  const headers = { ...defaultHeaders, ...customHeaders };
  const apiBaseURL = goUrl ? baseURLGo : baseURL;

  try {
    const response = await axios.post<T>(`${apiBaseURL}${url}`, bodyRequest, {
      headers
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error('erro');
    }
    throw new Error('Houve um problema com a requisição');
  }
}

export async function put<T>(
  url: string,
  bodyRequest: unknown,
  customHeaders: Record<string, unknown> = {},
  goUrl?: boolean
): Promise<T> {
  const headers = { ...defaultHeaders, ...customHeaders };
  const apiBaseURL = goUrl ? baseURLGo : baseURL;

  try {
    const response = await axios.put<T>(`${apiBaseURL}${url}`, bodyRequest, {
      headers
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data);
    }
    throw new Error('Houve um problema com a requisição.');
  }
}

export async function patch<T>(
  url: string,
  bodyRequest: unknown,
  customHeaders: Record<string, unknown> = {},
  goUrl?: boolean
): Promise<T> {
  const headers = { ...defaultHeaders, ...customHeaders };
  const apiBaseURL = goUrl ? baseURLGo : baseURL;

  try {
    const response = await axios.patch<T>(`${apiBaseURL}${url}`, bodyRequest, {
      headers
    });
    return response.data;
  } catch (error) {
    throw new Error('Houve um problema com a requisição.');
  }
}
